<template>
  <list-basic
    caption="名前"
    :description="$store.state.habit.name"
    :action="action"
  />
</template>

<script>
import ListBasic from '@/lib/List/Basic/index'

export default {
  components: {
    ListBasic
  },

  methods: {
    action () {
      this.$router.push({ name: 'habit-name' })
    }
  }
}
</script>
